<template>
  <section class="l-content-area">
    <div class="l-content l-content--reservation">
      <div class="l-wrap__outer">
        <div class="l-wrap__inner">
          <section class="c-title__bloc c-title__bloc--reservation">
            <h1>新規来店予約申し込み登録</h1>
            <div class="c-btn c-btn--title-back">
              <a href="#" @click="prevToStep()">
                戻る
              </a>
            </div>
          </section>

          <section class="p-bloc p-bloc__reservation">
            <h2 class="p-reservation__step">STEP 2</h2>

            <div class="p-reservation__bloc">
              <p>ご住所と希望スタジオを入力してください。</p>

              <div class="p-reservation__form">
                <dl class="c-form-parts">
                  <dt>ご住所<span>※ハイフン無し</span></dt>
                  <dd>
                    <input-zip-code
                      id="zipCode"
                      name="zipCode"
                      :value="values.zipCode"
                      :attrs="{ maxlength: 7 }"
                      :error="errors.zipCode"
                      @onHandleChange="onHandleChange"
                      @onValidate="onValidate"
                    >
                    </input-zip-code>
                  </dd>
                  <dd>
                    <input-select
                      id="state"
                      :value="values.state"
                      :value-selected="stateSelected.id"
                      :text-error="textErrors.state"
                      :list-data.sync="listState"
                      :default-value="'都道府県'"
                      :error="errors.state"
                      name="state"
                      @onHandleChange="onHandleChange"
                      @onValidate="onValidate"
                    >
                    </input-select>
                  </dd>
                  <dd>
                    <input-text
                      id="city"
                      name="city"
                      :value="values.city"
                      :placeholder="'市区町村'"
                      :text-error="textErrors.city"
                      :is-required="true"
                      :allowSpace="true"
                      :error="errors.city"
                      :max-length="255"
                      @onHandleChange="onHandleChange"
                      @onValidate="onValidate"
                    >
                    </input-text>
                  </dd>
                  <dd>
                    <input-text
                      id="address"
                      name="address"
                      :value="values.address"
                      :placeholder="'番地・ビル名'"
                      :text-error="textErrors.address"
                      :is-required="true"
                      :allowSpace="true"
                      :error="errors.address"
                      :max-length="255"
                      @onHandleChange="onHandleChange"
                      @onValidate="onValidate"
                    >
                    </input-text>
                  </dd>
                </dl>

                <dl class="c-form-parts">
                  <dt>ご来店希望スタジオ<span>※最寄り店舗を表示</span></dt>
                  <dd>
                    <input-select-group
                      :value="values.studio"
                      :text-error="textErrors.studio"
                      :list-data.sync="listStudio"
                      :list-all-data.sync="listAllStudio"
                      :error="errors.studio"
                      :default-value="'スタジオをお選びください'"
                      name="studio"
                      :value-selected="values.studio"
                      @onHandleChange="onHandleChange"
                      @onValidate="onValidate"
                    >
                    </input-select-group>
                  </dd>
                </dl>

                <dl v-if="studioInfo.postal_code || studioInfo.city" class="studio-info">
                  <dt>住所</dt>
                  <dd>
                    <span v-if="studioInfo.postal_code"> 〒{{ studioInfo.postal_code }} </span>
                    <br />
                    <span v-if="studioInfo.city">
                      {{ studioInfo.city }}
                    </span>
                    <span v-if="studioInfo.building">
                      {{ studioInfo.building }}
                    </span>
                    <br />
                  </dd>
                  <dt>営業時間／定休日</dt>
                  <dd v-if="studioInfo.opening_time">
                    <span v-if="studioInfo.opening_time">
                      平日：{{ studioInfo.opening_time.substring(0, 5) }} 〜
                    </span>
                    <span v-if="studioInfo.closing_time"
                      >{{ studioInfo.closing_time.substring(0, 5) }}
                    </span>
                    <br />
                    <span v-if="studioInfo.alt_opening_time">
                      土・日・祝：{{ studioInfo.alt_opening_time.substring(0, 5) }} 〜
                    </span>
                    <span v-if="studioInfo.alt_closing_time"
                      >{{ studioInfo.alt_closing_time.substring(0, 5) }}
                    </span>
                    <br />
                    <span> 定休日：{{ regularHolidayDisplay }} </span>
                    <br />
                  </dd>
                  <dt>アクセス</dt>
                  <dd v-html="studioInfo.nearest_station"></dd>
                </dl>
              </div>
              <div v-if="location" class="p-reservation__map">
                <div id="map">
                  <iframe
                    title="map"
                    :src="location"
                    width="600"
                    height="450"
                    style="border:0;"
                    allowfullscreen=""
                    aria-hidden="false"
                    tabindex="0"
                  >
                  </iframe>
                </div>
              </div>
            </div>

            <button-registration
              :next-text="'次へ'"
              :prev-text="'戻る'"
              :handle-next-button="nextToStep"
              :handle-prev-button="prevToStep"
              :prev-text-color="'#787878'"
            ></button-registration>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ButtonRegistration from '../common/ButtonRegistration'
import InputZipCode from '../common/InputZipCode'
import InputText from '../common/InputText'
import { ADDRESS_INVALID, CITY_INVALID, STATE_INVALID, STUDIO_INVALID } from '../../constant/text'
import { rulesValidateReservationAddress } from '../../helpers/schemaValidate'
import { scrollToTop } from '../../helpers'
import { getState, getStudio, updateUser } from '../../actions/requestReservation'
import InputSelect from '../common/InputSelect'
import InputSelectGroup from '../common/InputSelectGroup'
import { Core as YubinBangoCore } from '../../plugins/zipcode'
import { listDayJPName } from '../../constant/listDayJPName'

export default {
  name: 'ReservationAddress',
  components: {
    InputSelect,
    InputSelectGroup,
    InputText,
    InputZipCode,
    ButtonRegistration,
  },
  props: {
    currentStep: {
      type: String,
      default: '2',
    },
    isForceValidate: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: () => {
        return {
          zipCode: '',
          address: '',
          state: '',
          city: '',
          studio: '',
          region_id: '',
        }
      },
    },
  },
  data() {
    return {
      listState: [],
      listStudio: [],
      listAllStudio: [],
      listAllStudioInitial: [],
      stateSelected: {
        id: '',
        name: '',
      },
      studioInfo: {
        postal_code: '',
        city: '',
        building: '',
        opening_time: '',
        closing_time: '',
        alt_opening_time: '',
        alt_closing_time: '',
        nearest_station: '',
      },
      errors: {
        zipCode: '',
        address: '',
        state: '',
        city: '',
        studio: '',
      },
      textErrors: {
        city: CITY_INVALID,
        address: ADDRESS_INVALID,
        state: STATE_INVALID,
        studio: STUDIO_INVALID,
      },
      zip: null,
      locality: null,
      street: null,
      location: null,
    }
  },
  computed: {
    regularHolidayDisplay() {
      if (this.studioInfo.regular_holidays) {
        let arrregularHoliday = this.studioInfo.regular_holidays
            ? this.studioInfo.regular_holidays.split(',')
            : [],
          listName = [],
          strHoliday = ''
        arrregularHoliday.map((value, index) => {
          if (listDayJPName[value]) {
            listName.push(listDayJPName[value])
          }
        })
        strHoliday = listName.join(', ')
        return strHoliday
      }
      return ''
    },
  },
  watch: {
    isForceValidate(newVal) {
      if (newVal && this.currentStep === '2') {
        this.nextToStep()
      }
    },
    'values.state'(newVal) {
      this.$emit('onHandleChange', 'studio', '')
      this.studioInfo = {
        name: '',
        postal_code: '',
        city: '',
        building: '',
        opening_time: '',
        closing_time: '',
        alt_opening_time: '',
        alt_closing_time: '',
        nearest_station: '',
      }
      this.getStudios(newVal)
    },
    'values.studio'(newVal) {
      let studioSelected = this.listStudio.filter(studio => {
        return studio.id.toString() === newVal.toString()
      })

      if (studioSelected.length == 0) {
        studioSelected = this.listAllStudio.filter(studio => {
          return studio.id.toString() === newVal.toString()
        })
      }
      if (studioSelected.length > 0) {
        this.studioInfo = studioSelected[0]
        this.location = studioSelected[0]['map']
      } else {
        this.location = null
        this.studioInfo = {
          name: '',
          postal_code: '',
          city: '',
          building: '',
          opening_time: '',
          closing_time: '',
          alt_opening_time: '',
          alt_closing_time: '',
          nearest_station: '',
        }
      }
      this.$emit('onHandleChange', 'studioName', this.studioInfo.name)
    },

    'values.zipCode'(newVal) {
      if (newVal.length >= 7 && !isNaN(newVal)) {
        new YubinBangoCore(newVal, addr => {
          if (addr.region_id !== '') {
            this.onHandleChange('region_id', addr.region_id)
            this.onHandleChange('city', addr.locality + addr.street)
            this.onHandleChange('address', '')
            const listStateSelected = this.listState.filter(state => {
              return (
                state.id === `jp-${addr.region_id >= 10 ? addr.region_id : '0' + addr.region_id}`
              )
            })
            console.log(listStateSelected)
            if (listStateSelected.length > 0) {
              this.stateSelected = listStateSelected[0]
              this.onHandleChange('state', listStateSelected[0].id)
            }
          }
          // else {
          //   this.errors.zipCode = '郵便番号を入力してください'
          // }
        })
      } else {
        this.errors.zipCode = ''
        this.values.city = ''
        this.values.address = ''
      }
    },
  },
  created() {
    this.getState(this.values.region_id)
    this.getAllStudios()
  },
  methods: {
    nextToStep() {
      rulesValidateReservationAddress
        .validate(this.values, { abortEarly: false })
        .then(() => {
          this.$emit('startLoading')
          updateUser(this.userId, this.values, 'address')
            .then(response => {
              const {
                data: { success },
              } = response
              if (success && success === 1) {
                this.$emit('nextToStep', '3')
                this.$emit('endLoading')
              }
            })
            .catch(error => {
              this.$router.push({
                name: 'reservation-error',
              })
              return error
            })
        })
        .catch(err => {
          scrollToTop()
          err.inner.forEach(error => {
            this.errors[error.path] = error.message
          })
          this.$emit('endLoading')
        })
    },
    prevToStep() {
      this.$emit('prevToStep', 1)
    },
    onHandleChange(field, value) {
      this.$emit('onHandleChange', field, value)
    },
    onValidate(field, value) {
      this.errors[field] = value
      this.$emit('onValidateSwipe', false)
    },
    getAllStudios() {
      this.$emit('startLoading')
      getStudio()
        .then(res => {
          this.$emit('endLoading')
          const {
            data: { success },
          } = res
          if (success === 1) {
            const {
              data: { data },
            } = res
            this.listAllStudio = data
            this.listAllStudioInitial = data
          }
        })
        .catch(error => {
          this.$emit('endLoading')
          console.log(error)
        })
    },
    getStudios(stateId = '') {
      this.$emit('startLoading')
      getStudio(stateId)
        .then(res => {
          this.$emit('endLoading')
          const {
            data: { success },
          } = res
          if (success === 1) {
            const {
              data: { data },
            } = res
            if (stateId) {
              let state_id = stateId
              state_id = state_id.slice(3, 5)
              const listStudioSelected = data.filter(studio => {
                let prefecture_code = studio.prefecture_code
                if (parseInt(prefecture_code.slice(3, 5)) === parseInt(state_id)) {
                  return studio
                }
              })

              const listStudioNotSelected = this.listAllStudioInitial.filter(studio => {
                let prefecture_code = studio.prefecture_code
                if (parseInt(prefecture_code.slice(3, 5)) != parseInt(state_id)) {
                  return studio
                }
              })

              if (listStudioSelected.length > 0) {
                this.listStudio = listStudioSelected
              } else {
                this.listStudio = []
              }
              if (listStudioNotSelected.length > 0) {
                this.listAllStudio = listStudioNotSelected
              } else {
                this.listAllStudio = this.listAllStudioInitial
              }
            } else {
              //this.listStudio = data
            }
          }
        })
        .catch(error => {
          this.$emit('endLoading')
          console.log(error)
        })
    },
    getState(selectedValue = '') {
      this.$emit('startLoading')
      getState()
        .then(res => {
          this.$emit('endLoading')
          const {
            data: { success },
          } = res
          if (success === 1) {
            const responseListState = res.data.data
            this.listState = Object.keys(responseListState).map(key => {
              return {
                id: key,
                name: responseListState[key],
              }
            })
            if (selectedValue) {
              const listStateSelected = this.listState.filter(state => {
                return (
                  state.id === `jp-${selectedValue >= 10 ? selectedValue : '0' + selectedValue}`
                )
              })
              if (listStateSelected.length > 0) {
                this.stateSelected = listStateSelected[0]
                this.onHandleChange('state', listStateSelected[0].id)
              }
            }
          }
        })
        .catch(error => {
          this.$emit('endLoading')
          return error
        })
    },
  },
}
</script>

<style scoped>
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}

.v-application a {
  color: #0a005a;
}
</style>
